<template>
    <div class="dropdown border-default bg-primary-white" ref="dropdownWrap" id="dropdown-container">
        <button
            :id="automationId"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            :disabled="!options.length"
            class="align-items-center w-100 border-0 d-flex h-100 outline-none text-nowrap bg-primary-white line-height-0 cursor-pointer position-absolute top-0 left-0 bg-none"
            :class="{
                ...(classesToggle || {}),
                'border-disabled': !options.length
            }"
            ref="dropdown"
        >
            <slot name="icon-left"></slot>
            <div
                class="d-flex align-items-center justify-content-between text-left text-nowrap text-elipsis subcaption text-primary-black content text-elipsis"
                :class="{ 'text-disabled': !options.length, 'subcaption-strong': selected.length > 0 }"
            >
                <template v-if="automationId !== 'ski-formula'">
                    {{ selected.length > 0 ? selectedLabel : label }}
                </template>

                <template v-else>
                <span v-if="selectedWithIcons.length" class="d-flex align-items-center gap-1">
                    <span
                        v-for="(selectedItem, i) in selectedWithIcons"
                        :key="selectedItem.label + i"
                        class="d-flex align-items-center gap-1"
                    >
                        <span
                            v-for="(part, j) in splitLabelWithIcons(selectedItem)"
                            :key="part.label + j"
                            class="d-flex align-items-center gap-1"
                        >
                            <component
                                v-if="part.icon"
                                :is="part.icon"
                                color="black"
                                width="20"
                            />
                            <span>{{ part.label }}</span>
                            <span v-if="part.showPlus">+</span>
                            <span
                                v-if="!part.showPlus && !(i === selectedWithIcons.length - 1 && j === splitLabelWithIcons(selectedItem).length - 1)"
                            >
                                ,
                            </span>
                        </span>
                    </span>
                </span>
                <span v-else>{{ label }}</span>
                </template>
            </div>

            <span class="justify-content-end flex-grow-1 arrow-up">
                <ArrowUp></ArrowUp>
            </span>
            <span class="justify-content-end flex-grow-1 arrow-down">
                <ArrowDown></ArrowDown>
            </span>
        </button>
        <ul
            class="dropdown-menu text-primary-black text-elipsis tf-scroll-container--50vh"
            :style="{ width: dropdownWidth ? dropdownWidth : '100%' }"
            @click.stop
        >
            <li
                class="py-1 px-4 cursor-pointer d-flex align-items-center text-elipsis subcaption"
                v-for="item in options"
                @click="toggle(item)"
                :key="item.label"
            >
                <div class="form-check">
                    <input class="ts-form-check-input" type="checkbox" :checked="item.isSelected" />
                </div>
                <span
                    class="ms-2 text-wrap d-flex"
                    :class="{
                        'subcaption-strong text-primary-blue': item.isSelected
                    }"
                >
                <span
                    v-for="(part, index) in splitLabelWithIcons(item)"
                    :key="part.label + index"
                    class="d-flex align-items-center"
                >
                    <component
                        :is="part.icon"
                        :color="'black'"
                    />
                    <span class="me-1">{{ part.label }}</span>
                    <span v-if="part.showPlus">+</span>
                </span>
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
import ArrowUp from '@se/components/svg/common/arrow-up/index.vue'
import ArrowDown from '@se/components/svg/common/arrow-down/index.vue'
import { onClickOutside } from '@vueuse/core'

export default {
    name: 'DropdownItems',
    components: {
        ArrowUp,
        ArrowDown
    },
    props: {
        store: Object,
        events: Object,
        filter: Object,
        classesToggle: Object,
        label: String,
        dropdownWidth: String,
        automationId: String
    },
    data() {
        return {
            off: [],
            state: {
                wasDefaultSelected: false
            }
        }
    },
    computed: {
        se() {
            return this.store.libs.se
        },
        items() {
            return this.filter.sort ? this.filter.items.sort((a, b) => (a.label > b.label ? 1 : -1)) : [...this.filter.items]
        },
        options() {
            // Keep this 'setDefaultSelected' method, one per month business change their mind about the default selected item
            // this.setDefaultSelected()

            return this.filter.items
                .filter((item) => this.isAvailable(item))
                .map((item) => {
                    return {
                        ...item,
                        isSelected: this.isSelected(item)
                    }
                })
        },
        selected() {
            return this.filter.items.filter((item) => this.isSelected(item))
        },
        selectedLabel() {
            return this.selected.map(({ label }) => label).join(', ')
        },
        selectedWithIcons() {
            return this.selected.map(({ label, icons }) => ({
                label,
                icons
            }));
        }
    },
    methods: {
        isSelected(item) {
            // this.store.state.updateCounters; // keep this statement to trigger recalculation
            this.store.state.updateFilters // keep this statement to trigger recalculation
            return this.se.isSelected({ ...item, availableOnly: true })
        },
        isAvailable(item) {
            this.store.state.updateCounters // keep this statement to trigger recalculation
            return this.se.isAvailable(item)
        },
        toggle(item) {
            console.log("available: ", this.store.data.available)
            if (item.isSelected) {
                this.remove(item)
            } else {
                this.add(item)
            }
        },
        remove({ values, criterias }) {
            this.se.remove({ values, criterias })
        },
        add(item) {
            const available = this.se.getAvailable(item)
            this.se.add(available)
        },
        clear() {
            const values = this.filter.items.flatMap(({ values = [] }) => values)
            const criterias = this.filter.items.flatMap(({ criterias = [] }) => criterias)
            this.se.remove({ values, criterias })
            this.showDropdown()
        },
        showDropdown: function () {
            $(this.$refs.dropdown).dropdown('show')
        },
        closeDropdown() {
            $(this.$refs.dropdown).dropdown('hide')
        },
        splitLabelWithIcons(item) {
            const labels = item.label.split(/\s*\+\s*/); // Split by '+', trimming spaces
            const icons = item.icons || [];

            return labels.map((label, index) => ({
                label,
                icon: icons[index] || null,
                showPlus: index < labels.length - 1 // true if not the last label
            }));
        },
        setDefaultSelected() {
            // Automatically select the first item if the field is 'packages' and locale is 'nl_NL'
            const firstItem = this.filter.items[0];
            if(firstItem.values[0].field === 'packages' && this.store.locale === 'nl_NL' && !this.state.wasDefaultSelected)  {
                this.add(firstItem)
                if(this.isAvailable(firstItem)) this.state.wasDefaultSelected = true
            }
        }
    },
    beforeDestroy: function () {
        this.off.forEach((off) => off())
        $(this.$refs.dropdown).dropdown('dispose')
    },
    mounted: function () {
        var self = this
        if (this.events) {
            this.events.on('show', function () {
                self.showDropdown()
            })
            this.events.on('hide', function () {
                $(self.$refs.dropdown).dropdown('hide')
            })
        }
        var dropdownWrap = $(this.$refs.dropdownWrap)
        dropdownWrap.on('show.bs.dropdown', function () {
            try {
                self.$emit('show')
            } catch (e) {}
        })
        dropdownWrap.on('shown.bs.dropdown', function () {
            self.$emit('show')
            setTimeout(function () {
                // $(self.$refs.dropdownWrap).addClass('show')
            }, 1000)
        })
        dropdownWrap.on('hide.bs.dropdown', function () {
            self.$emit('hide')
        })
        dropdownWrap.on('hidden.bs.dropdown', function () {
            self.$emit('hidden')
        })

        onClickOutside(this.$refs.dropdown, () => {
            $(this.$refs.dropdown).dropdown('hide')
        })
    }
}
</script>

<style scoped>
button[aria-expanded='true'] .arrow-down,
button[aria-expanded='false'] .arrow-up {
    display: flex;
}

button[aria-expanded='false'] .arrow-down,
button[aria-expanded='true'] .arrow-up {
    display: none;
}
</style>
